import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\SmartSearchController::interpret
* @see app/Http/Controllers/SmartSearchController.php:18
* @route '/api/search/interpret'
*/
export const interpret = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: interpret.url(options),
    method: 'post',
})

interpret.definition = {
    methods: ["post"],
    url: '/api/search/interpret',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SmartSearchController::interpret
* @see app/Http/Controllers/SmartSearchController.php:18
* @route '/api/search/interpret'
*/
interpret.url = (options?: RouteQueryOptions) => {
    return interpret.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SmartSearchController::interpret
* @see app/Http/Controllers/SmartSearchController.php:18
* @route '/api/search/interpret'
*/
interpret.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: interpret.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SmartSearchController::interpret
* @see app/Http/Controllers/SmartSearchController.php:18
* @route '/api/search/interpret'
*/
const interpretForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: interpret.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SmartSearchController::interpret
* @see app/Http/Controllers/SmartSearchController.php:18
* @route '/api/search/interpret'
*/
interpretForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: interpret.url(options),
    method: 'post',
})

interpret.form = interpretForm

/**
* @see \App\Http\Controllers\SearchController::count
* @see app/Http/Controllers/SearchController.php:155
* @route '/api/search/count'
*/
export const count = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: count.url(options),
    method: 'get',
})

count.definition = {
    methods: ["get","head"],
    url: '/api/search/count',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SearchController::count
* @see app/Http/Controllers/SearchController.php:155
* @route '/api/search/count'
*/
count.url = (options?: RouteQueryOptions) => {
    return count.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SearchController::count
* @see app/Http/Controllers/SearchController.php:155
* @route '/api/search/count'
*/
count.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: count.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SearchController::count
* @see app/Http/Controllers/SearchController.php:155
* @route '/api/search/count'
*/
count.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: count.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SearchController::count
* @see app/Http/Controllers/SearchController.php:155
* @route '/api/search/count'
*/
const countForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: count.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SearchController::count
* @see app/Http/Controllers/SearchController.php:155
* @route '/api/search/count'
*/
countForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: count.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SearchController::count
* @see app/Http/Controllers/SearchController.php:155
* @route '/api/search/count'
*/
countForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: count.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

count.form = countForm

/**
* @see \App\Http\Controllers\SearchController::similar
* @see app/Http/Controllers/SearchController.php:169
* @route '/api/search/similar'
*/
export const similar = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: similar.url(options),
    method: 'get',
})

similar.definition = {
    methods: ["get","head"],
    url: '/api/search/similar',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SearchController::similar
* @see app/Http/Controllers/SearchController.php:169
* @route '/api/search/similar'
*/
similar.url = (options?: RouteQueryOptions) => {
    return similar.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SearchController::similar
* @see app/Http/Controllers/SearchController.php:169
* @route '/api/search/similar'
*/
similar.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: similar.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SearchController::similar
* @see app/Http/Controllers/SearchController.php:169
* @route '/api/search/similar'
*/
similar.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: similar.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SearchController::similar
* @see app/Http/Controllers/SearchController.php:169
* @route '/api/search/similar'
*/
const similarForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: similar.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SearchController::similar
* @see app/Http/Controllers/SearchController.php:169
* @route '/api/search/similar'
*/
similarForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: similar.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SearchController::similar
* @see app/Http/Controllers/SearchController.php:169
* @route '/api/search/similar'
*/
similarForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: similar.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

similar.form = similarForm

const search = {
    interpret: Object.assign(interpret, interpret),
    count: Object.assign(count, count),
    similar: Object.assign(similar, similar),
}

export default search